import { formatSymbol } from "@/utils/i18n/format-symbol";

import { backtest } from "./backtest";
import { chip } from "./chip";
import { dividend } from "./dividend";
import { financialReports } from "./financial-reports";
import { historicalRating } from "./historical-rating";
import { navigation } from "./navigation";
import { overview } from "./overview";
import { relatedSymbol } from "./related-symbol";
import { scoreDescription } from "./score-description";
import { search } from "./search";
import { shared } from "./shared";
import { stockSentiment } from "./stock-sentiment";
import { swing } from "./swing";
import { trend } from "./trend";
import { value } from "./value";

export const analysis = {
  zh: {
    noSymbol: ({ symbol }: { symbol: string }) => `${symbol} 此檔標的不存在`,
    checkOtherSymbol: "前往查看其他標的",
    noScore: "無法評分",
    noSymbolData: ({ symbol }: { symbol: string }) =>
      `目前資料不足，AI 尚且無法給予 ${formatSymbol(symbol)} 評分`,
    analysis: "分析",

    shared: shared.zh,
    search: search.zh,
    overview: overview.zh,
    chip: chip.zh,
    dividend: dividend.zh,
    trend: trend.zh,
    value: value.zh,
    swing: swing.zh,
    historicalRating: historicalRating.zh,
    backtest: backtest.zh,
    relatedSymbol: relatedSymbol.zh,
    navigation: navigation.zh,
    scoreDescription: scoreDescription.zh,
    financialReports: financialReports.zh,
    stockSentiment: stockSentiment.zh,
    viewChart: "查看圖表",
    viewSlides: "財報簡報檔",
    viewSlidesNoFile: ({ symbol }: { symbol: string }) =>
      `${formatSymbol(symbol)} 無簡報檔`,
    viewSlidesDialogNoPermissionTitle: "貼心小提醒",
    viewSlidesDialogNoPermissionContent:
      "上市公司的「財報簡報檔」僅提供基本／進階付費會員下載喔！可點擊下方按鈕前往付費解鎖下載。",
    viewSlidesDialogNoPermissionButtonText: "前往訂閱或升級",
  },
  en: {
    noSymbol: ({ symbol }: { symbol: string }) =>
      `${formatSymbol(symbol)} does not exist.`,
    checkOtherSymbol: "Go check out other options.",
    noScore: "No score",
    noSymbolData: ({ symbol }: { symbol: string }) =>
      `Due to insufficient data, AI is currently unable to assign a rating to ${formatSymbol(
        symbol
      )}. `,
    analysis: " Analysis",

    shared: shared.en,
    search: search.en,
    overview: overview.en,
    chip: chip.en,
    dividend: dividend.en,
    trend: trend.en,
    value: value.en,
    swing: swing.en,
    historicalRating: historicalRating.en,
    backtest: backtest.en,
    relatedSymbol: relatedSymbol.en,
    navigation: navigation.en,
    scoreDescription: scoreDescription.en,
    financialReports: financialReports.en,
    stockSentiment: stockSentiment.en,
    viewChart: "View Chart",
    viewSlides: "Report Slides",
    viewSlidesNoFile: ({ symbol }: { symbol: string }) =>
      `No presentation for ${formatSymbol(symbol)}`,
    viewSlidesDialogNoPermissionTitle: "Kindly Reminder",
    viewSlidesDialogNoPermissionContent:
      "The “Financial Presentation” files are only available to Basic or Premium paid members! You can click the button below to upgrade and unlock the restriction.",
    viewSlidesDialogNoPermissionButtonText: "Buy or Upgrade",
  },
};
